/**
 * F4 — Mockup Preview as an explicit intent.
 *
 * Reuses the shared mockup-composite util so this intent's behavior matches
 * the dialog's Result-slot mockup row exactly. Pure-`run` handler (no
 * mountControls) — pick the intent → composite all manifest templates → first
 * tile becomes the Result-slot image, full tile list rides in metadata for
 * the future "tile picker" UX (v2).
 */

import { registerClientHandler } from './registry.js'
import { loadManifest, composeOne } from '../utils/mockup-composite.js'

export const cachedTemplateHandler = {
  /**
   * @param {{ image: string, config: Object, intent: Object }} ctx
   */
  async run(ctx) {
    if (!ctx.image) {
      throw new Error('Source image required for mockup preview')
    }

    const templates = await loadManifest()
    if (!templates.length) {
      throw new Error('No mockup templates configured. Check /templates/mockups/index.json')
    }

    const tiles = await Promise.all(templates.map(t => composeOne(t, ctx.image)))
    const primary = tiles[0]
    if (!primary?.dataUrl) {
      throw new Error('Mockup composite produced no tiles')
    }

    return {
      result_data_url: primary.dataUrl,
      metadata: {
        tile_count: tiles.length,
        primary_template: primary.id,
        all_templates: tiles.map(t => ({ id: t.id, dataUrl: t.dataUrl })),
      },
    }
  },
}

registerClientHandler('cachedTemplateHandler', cachedTemplateHandler)
